<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Arrow.back"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_969" data-name="Group 969">
      <path
        id="Path_8354"
        data-name="Path 8354"
        d="M19,12H5m9,5,5-5M14,7l5,5"
        fill="none"
        :stroke="clr ? clr : '#002'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8355" data-name="Path 8355" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
